import { render } from "./workflowphase-list.vue?vue&type=template&id=42afe9f3"
import script from "./workflowphase-list.vue?vue&type=script&lang=js"
export * from "./workflowphase-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__